import { buildScopedI18n } from '../../utils/buildScopedI18n';
import prEsCL from './locales/es-CL.json';
import prEnUS from './locales/en-US.json';
import prPtBR from './locales/pt-BR.json';

export const protocolsI18n = buildScopedI18n({
  esCL: prEsCL,
  enUS: prEnUS,
  ptBR: prPtBR,
});
